import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "data-aos": "fade-in",
  class: "grid lg:grid-cols-2 items-center justify-center my-8 mx-4 lg:mt-8 lg:mx-auto gap-4 lg:gap-16 text-center"
}
const _hoisted_2 = { class: "py-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-2xl pb-4 pt-2" }, "current progress", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "pb-8 text-sm" }, "how many words do I remember?", -1)
const _hoisted_5 = { class: "lg:px-16" }
const _hoisted_6 = { class: "py-8" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-2xl pb-4 pt-2" }, "next review", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "pb-8 text-sm" }, "how many reviews in the next few days?", -1)
const _hoisted_9 = { class: "lg:px-16" }

import { gtag } from "@/gtag";
import { onMounted } from "vue";
import NextReviewChart from "../components/charts/NextReviewChart.vue";
import TotalProgressDonut from "../components/charts/TotalProgressDonut.vue";
//import MyCard from "../components/MyCard.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

onMounted(() => {
  gtag.event("page:stats");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(TotalProgressDonut)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createVNode(NextReviewChart)
      ])
    ])
  ]))
}
}

})